'use client'

import { useSyncExternalStore } from 'react'
import { isInTranslatorIframe } from './inTranslatorIframe'

const getServerSnapshot = () => false

function subscribe(onStoreChange: () => void) {
  const timeout = window.setTimeout(onStoreChange, 0)
  return () => window.clearTimeout(timeout)
}

export function useInTranslatorIframe(): boolean {
  return useSyncExternalStore(subscribe, isInTranslatorIframe, getServerSnapshot)
}
